var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"myAccountSettings"},[_c('v-sheet',{staticClass:"pa-5"},[_c('v-switch',{attrs:{"inset":"","label":"Christmas animations"},model:{value:(_vm.christmas),callback:function ($$v) {_vm.christmas=$$v},expression:"christmas"}})],1),_c('theme-toggle')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }